import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface APIResponse {
  resData: ResData;
}

export interface ResData {
  totalStudents: number;
  averageAttendance: string;
  totalClasses: number;
  classDuration: number;
  RecentattendanceRecords: Array<RecentattendanceRecord>;
  pagination: Pagination;
}

export interface RecentattendanceRecord {
  date: string;
  studentPresent: string;
  attendanceRate: string;
}

export interface Pagination {
  totalPages: number;
  totalItems: number;
}

export interface GetClassAnalyticsParams {
  enrollmentId: string;
  limit?: number;
  page?: number;
}

export const getClassAnalytics = async ({
  enrollmentId,
  page = 1,
  limit = 10,
}: GetClassAnalyticsParams) => {
  const response = await baseAPI.get<APIResponse>(
    `/students/attendance/analytics/${enrollmentId}`,
    {
      params: {
        page,
        limit,
      },
    },
  );
  return response.data;
};

export const getClassAnalyticsOptions = (params: GetClassAnalyticsParams) =>
  queryOptions({
    queryKey: [KEYS.CLASS_ANALYTICS, params],
    queryFn: () => getClassAnalytics(params),
    staleTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
  });

export const useGetClassAnalytics = (params: GetClassAnalyticsParams) => {
  return useQuery(getClassAnalyticsOptions(params));
};
